import type { PropsWithChildren } from 'react';
import { PLACEHOLDERS } from '../../constants/pdf-preview.ts';
import { usePlaceholders } from '../placeholders-context.tsx';

export function FooterPlaceholder({ children }: PropsWithChildren): React.ReactNode {
  const { showPlaceholder } = usePlaceholders(PLACEHOLDERS.Footer);

  if (showPlaceholder) {
    return null;
  }

  return <>{children}</>;
}
